module.exports = __webpack_public_path__ + "img/jnbac.0f03443d.png";